import React, { useState } from 'react'
import { supabase } from '../../supabase'

const Index = () => {
  const [showModal, setShowModal] = useState(false);
  const [targetUrl, setTargetUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    whatsapp: ''
  });

  const handleModal = (url) => {
    setTargetUrl(url);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setTargetUrl('');
    setIsLoading(false);
    setFormData({ nome: '', email: '', whatsapp: '' });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const saveUserToSupabase = async (userData) => {
    try {
      // Check if user already exists by email
      const { data: existingUser, error: fetchError } = await supabase
        .from('users')
        .select('id')
        .eq('email', userData.email)
        .maybeSingle();

      if (fetchError) {
        console.error('Error checking user existence in Supabase:', fetchError);
        throw fetchError;
      }

      if (existingUser) {
        // User already exists, do not insert
        return existingUser;
      }

      // Insert only if not in database
      const { data, error } = await supabase
        .from('users')
        .insert([
          {
            name: userData.nome,
            email: userData.email,
            whatsapp: userData.whatsapp,
            status: 'inactive',
            plan: 'lead'
          }
        ]);

      if (error) {
        console.error('Error saving user to Supabase:', error);
        throw error;
      }

      return data;
    } catch (error) {
      console.error('Failed to save user:', error);
      throw error;
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form
    if (!formData.nome || !formData.email || !formData.whatsapp) {
      alert('Por favor, preencha todos os campos.');
      return;
    }

    // Validate email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      alert('Por favor, insira um email válido.');
      return;
    }

    setIsLoading(true);

    try {
      // Save user data to Supabase
      await saveUserToSupabase(formData);
      
      // Redirect to Kiwify after successful save
      window.location.href = targetUrl;
    } catch (error) {
      setIsLoading(false);
      alert('Ocorreu um erro ao processar seus dados. Tente novamente.');
      console.error('Error in form submission:', error);
    }
  };

  return (
    <div className="min-h-screen bg-white m-0 p-0 " style={{fontFamily: "Poppins, sans-serif"}}>
      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl p-8 max-w-md w-full mx-4 relative">
            <button
              onClick={handleCloseModal}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition"
              disabled={isLoading}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            
            <div className="text-center mb-6">
              <h3 className="text-2xl font-bold text-gray-800 mb-2">Quase lá!</h3>
              <p className="text-gray-600">Preencha seus dados para continuar</p>
            </div>

            <form onSubmit={handleFormSubmit} className="space-y-4">
              <div>
                <label htmlFor="nome" className="block text-sm font-medium text-gray-700 mb-2">
                  Nome completo *
                </label>
                <input
                  type="text"
                  id="nome"
                  name="nome"
                  value={formData.nome}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition"
                  placeholder="Seu nome completo"
                  required
                  disabled={isLoading}
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition"
                  placeholder="seu@email.com"
                  required
                  disabled={isLoading}
                />
              </div>

              <div>
                <label htmlFor="whatsapp" className="block text-sm font-medium text-gray-700 mb-2">
                  WhatsApp *
                </label>
                <input
                  type="tel"
                  id="whatsapp"
                  name="whatsapp"
                  value={formData.whatsapp}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition"
                  placeholder="(11) 99999-9999"
                  required
                  disabled={isLoading}
                />
              </div>

              <div className="flex gap-3 mt-6">
                <button
                  type="submit"
                  className="w-full px-4 py-3 bg-orange-600 hover:bg-orange-700 disabled:bg-orange-400 disabled:cursor-not-allowed text-white rounded-lg transition font-medium flex items-center justify-center"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Processando...
                    </>
                  ) : (
                    'Continuar'
                  )}
                </button>
              </div>

              <div className="flex gap-3 mt-6">
                <p className="text-gray-600 text-sm">
                  Os seus dados estão seguros, não compartilhamos com ninguém.
                </p>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Header */}
      <header className="bg-gray-900   sticky top-0 z-50">
        <nav className="container mx-auto px-6 py-4 flex justify-between items-center max-w-[1100px] mx-auto" >
          <div className="flex items-center">
            {/* LOGO */}
            <span className="text-2xl font-bold text-white flex items-center gap-2"> 
              <img src="/images/logo_h.png" alt="Hotify" className="w-10 h-10" />
              <span className="">Hotify</span>
              </span>
          </div>
          <div className="hidden md:flex space-x-8">
            <a href="#inicio" className="text-white/80 hover:text-white font-medium transition">Início</a>
            <a href="#funcionalidades" className="text-white/80 hover:text-white font-medium transition">Funcionalidades</a>
            <a href="#planos" className="text-white/80 hover:text-white font-medium transition">Planos</a>
            <a href="https://wa.me/5521997126415?text=Olá tenho interesse em ser parceiro da Hotify" className="text-white/80 hover:text-white font-medium transition">Parceiros</a>
          </div>
          <div>
            <a href="/dashboard" className="text-white text-sm  border-1 border-gray-800  px-5 py-2 rounded-lg font-semibold shadow   transition">Fazer Login</a>
          </div>
        </nav>
      </header>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/5521997126415?text=Ol%C3%A1!%20Gostaria%20de%20tirar%20algumas%20d%C3%BAvidas%20sobre%20a%20Hotify"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-orange-600"
        style={{
          position: 'fixed',
          bottom: '15px',
          right: '15px',
          zIndex: 1000,
          
          borderRadius: '50%',
          width: '60px',
          height: '60px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
        }}
        aria-label="Fale conosco no WhatsApp"
      >
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="white"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path d="M16.001 3.2c-7.07 0-12.8 5.73-12.8 12.8 0 2.26.6 4.47 1.74 6.41L3.2 28.8l6.59-1.72A12.74 12.74 0 0 0 16 28.8c7.07 0 12.8-5.73 12.8-12.8s-5.73-12.8-12.799-12.8zm0 23.04c-2.07 0-4.1-.54-5.87-1.56l-.42-.24-3.91 1.02 1.04-3.81-.27-.44A10.57 10.57 0 0 1 5.44 16c0-5.83 4.73-10.56 10.56-10.56 5.83 0 10.56 4.73 10.56 10.56 0 5.83-4.73 10.56-10.56 10.56zm5.8-7.91c-.32-.16-1.89-.93-2.18-1.04-.29-.11-.5-.16-.71.16-.21.32-.82 1.04-1.01 1.25-.19.21-.37.24-.69.08-.32-.16-1.36-.5-2.59-1.59-.96-.86-1.61-1.92-1.8-2.24-.19-.32-.02-.5.14-.66.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.71-1.71-.97-2.34-.26-.62-.53-.54-.71-.55-.18-.01-.39-.01-.6-.01-.21 0-.56.08-.85.4-.29.32-1.12 1.09-1.12 2.66 0 1.57 1.15 3.09 1.31 3.3.16.21 2.27 3.47 5.51 4.73.77.3 1.37.48 1.84.61.77.2 1.47.17 2.02.1.62-.09 1.89-.77 2.16-1.51.27-.74.27-1.37.19-1.51-.08-.14-.29-.21-.61-.37z"/>
          </g>
        </svg>
      </a>


      {/* Hero Section */}
      <section className="  mx-auto px-4 py-16 text-center bg-gray-900">
        <div className="max-w-4xl mx-auto">
          
          <h1 className="text-xl md:text-2xl text-white mb-8 leading-relaxed max-w-3xl mx-auto">
         <span className="text-orange-500 font-semibold">  Aumente seu ROI em até 7x</span> transformando visitantes em  clientes gastando <span className="text-orange-500 font-semibold">3x menos</span> do que você gasta hoje!
          </h1>
           

          {/* Video/Demo Section */}
          <div className="bg-gray-100 rounded-2xl p-0 mb-16">
            <div className="aspect-video bg-gray-300 rounded-xl flex items-center justify-center">
              <div className="w-full h-full">
                <iframe
                  className="w-full h-full rounded-xl"
                  src="https://www.youtube.com/embed/Fg1wI7e_i2M"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  style={{ display: 'block' }}
                ></iframe>
              </div>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <a href="#planos" className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-3 rounded-lg text-lg font-semibold transition-colors cursor-pointer">
            Veja os planos
            </a>
            <button onClick={() => window.location.href = "https://hotify.ai/starter"} className="border-2 border-orange-600 text-orange-600 hover:bg-orange-600 hover:text-white px-8 py-3 rounded-lg text-lg font-semibold transition-colors cursor-pointer">
            Teste na prática
            </button>
          </div>
          </div>

          
      </section>
  


      {/* Features Section */}
      <section id="funcionalidades" className="container mx-auto px-4 py-16 max-w-[1100px] mx-auto">

        
        <div className="text-center mb-16">
          {/* Integrations */}
          <div className="mb-16">
            <h2 className="text-gray-900 mb-6 text-2xl font-semibold">Simplesmente perfeita para quem utiliza:</h2>
            <div className="relative w-full overflow-hidden">
              <div
                className="flex items-center gap-8 opacity-60 animate-marquee"
                style={{
                  animation: 'marquee 35s linear infinite',
                  minWidth: 'fit-content',
                }}
              >
                {[
                  { src: '/images/platforms/hotmart.png', alt: 'Hotmart' },
                  { src: '/images/platforms/kiwify.png', alt: 'Kiwify' },
                  { src: '/images/platforms/monetizze.png', alt: 'Monetizze' },
                  { src: '/images/platforms/braip.png', alt: 'Braip' },
                  { src: '/images/platforms/eduzz.png', alt: 'Eduzz' },
                  { src: '/images/platforms/kirvano.png', alt: 'Kirvano' },
                  { src: '/images/platforms/perfectpay.png', alt: 'PerfectPay' },
                  { src: '/images/platforms/ticto.png', alt: 'Ticto' },
                ].concat([
                  // Duplicate for infinite effect
                  { src: '/images/platforms/hotmart.png', alt: 'Hotmart' },
                  { src: '/images/platforms/kiwify.png', alt: 'Kiwify' },
                  { src: '/images/platforms/monetizze.png', alt: 'Monetizze' },
                  { src: '/images/platforms/braip.png', alt: 'Braip' },
                  { src: '/images/platforms/eduzz.png', alt: 'Eduzz' },
                  { src: '/images/platforms/kirvano.png', alt: 'Kirvano' },
                  { src: '/images/platforms/perfectpay.png', alt: 'PerfectPay' },
                  { src: '/images/platforms/ticto.png', alt: 'Ticto' },
                ]).map((platform, idx) => (
                  <div className="px-4 py-2 rounded-lg flex-shrink-0" key={idx}>
                    <img src={platform.src} alt={platform.alt} className="h-10" />
                  </div>
                ))}
              </div>
              <style>
                {`
                  @keyframes marquee {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-50%); }
                  }
                  .animate-marquee {
                    width: max-content;
                  }
                `}
              </style>
            </div>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Prático, Rápido e Intuitivo.
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Construa o seu sistema com uma interface 100% arrastar e soltar.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {/* Feature 1 */}
          <div className="text-center p-6">
            <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">Uma experiência única</h3>
            <p className="text-gray-600">
              Proporcione uma experiência totalmente única para o seu cliente, antes de qualquer outro concorrente.
            </p>
          </div>

          {/* Feature 2 */}
          <div className="text-center p-6">
            <div className="w-16 h-16   rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">Muito mais velocidade</h3>
            <p className="text-gray-600">
              O Hotify é totalmente otimizado para poupar o seu tempo e te ajudar a testar muito mais rápido.
            </p>
          </div>

          {/* Feature 3 */}
          <div className="text-center p-6">
            <div className="w-16 h-16  rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">25+ Elementos Interativos</h3>
            <p className="text-gray-600">
              São mais 25 elementos interativos que você pode utilizar para criar o seu sistema.
            </p>
          </div>

          {/* Feature 4 */}
          <div className="text-center p-6">
            <div className="w-16 h-16  rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">Variáveis dinâmicas</h3>
            <p className="text-gray-600">
              É possível capturar dados do seu cliente, e a partir disso definir as próximas páginas do seu sistema.
            </p>
          </div>

          {/* Feature 5 */}
          <div className="text-center p-6">
            <div className="w-16 h-16  rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">Integrações</h3>
            <p className="text-gray-600">
              É possível integrar o Hotify com várias ferramentas que você já utiliza.
            </p>
          </div>

          {/* Feature 6 */}
          <div className="text-center p-6">
            <div className="w-16 h-16  rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">Tudo em um só lugar</h3>
            <p className="text-gray-600">
              Com o Hotify, você não precisa mais de hospedagem ou qualquer outro serviço.
            </p>
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="bg-gray-50 py-16" style={{display: "none"}}>
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="w-20 h-20 bg-gray-200 rounded-full mx-auto mb-6"></div>
              <blockquote className="text-xl text-gray-700 mb-6 italic">
                "Utilizo o Hotify desde o lançamento e já faturamos mais de 2 milhões com essa ferramenta. Além de utilizar na minha operação, estou indicando para todos os meus alunos."
              </blockquote>
              <div className="text-gray-800 font-semibold">João Silva</div>
              <div className="text-gray-600 text-sm">Empreendedor Digital e Mentor</div>
            </div>
          </div>
        </div>
      </section>

      {/* Timeline Section */}
      <section className="py-10  max-w-[1100px] mx-auto" >
        <div className="  mx-auto px-4">
                  
        <div className="text-center mb-16">
       
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4 mx-auto">
            Hotify é para quem:
          </h2>
         
          </div>
        
       


          <div className="max-w-4xl mx-auto">
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-orange-600 mb-2 ">Vende Low Ticket</div> 
                <p className="text-gray-600 text-sm">
                  Se você vende produtos como ebook, cursos, treinamentos, etc... de até R$100,00 a Hotify é mais do que perfeita para você. O custo de nossa plataforma é calculado justamente para que você tenha uma margem alta sem precisar gastar com VSL, domínio, Hospedagem, criação de Landing Pages, etc. 
                  </p>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-orange-600 mb-2">Valida Oferta e Público</div> 
                <p className="text-gray-600 text-sm flex justify-between">A simplicidade e rapidez de criar uma landing page / página de vendas com a nossa ferramenta faz com que você foque no que importa: Validar oferta e público sem dor de cabeça e escalar quando acertar a boa.</p>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-orange-600 mb-2">Captura Leads</div> 
                <p className="text-gray-600 text-sm ">Seja você marketeiro, corretor, influencer, micro-saas owner, etc... Você precisa de Leads qualificados. Com a Hotify você consegue criar quiz/funis para qualificar os seus leads de uma maneira fácil rápida e economica. </p>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-orange-600 mb-2">Quer gastar pouco</div> 
                <p className="text-gray-600 text-sm">Se você está iniciando no Digital e não quer gastar com VSL, Domínio, Hospedagem, Locutor, Copywriter, etc... A Hotify é perfeita para você, pois descarta a necessidade de tudo isso até você validar seu produto e fazer as suas primeiras vendas.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="bg-gray-900 text-white py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold mb-2">10k+</div>
              <div className="text-lg opacity-90">acessos diários em nossos sistemas</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">2k+</div>
              <div className="text-lg opacity-90">projetos criados com o Hotify</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">1k+</div>
              <div className="text-lg opacity-90">clientes já atendidos</div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="planos" className="py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Pronto para começar?
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              Planos para todos os negócios.
            </p>
            <p className="text-lg text-gray-600">
              Comece a criar experiências incríveis para os seus clientes ainda hoje.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-5 max-w-6xl mx-auto">
            {/* Basic Plan */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Starter</h3>
              <p className="text-gray-600 mb-4">Ideal para quem está começando e quer conhecer a plataforma.</p>
              <div className="text-3xl font-bold text-orange-600 mb-6">
                <span style={{color: "green", fontSize: "19px"}}><small>*Vagas limitadas</small></span><br></br>
                R$ 47,00<span className="text-lg font-normal text-orange-600">/mês</span>
              </div>
              <button
                onClick={() => handleModal("https://pay.kiwify.com.br/p5EzLpa")}
                className="w-full bg-orange-600 hover:bg-orange-700 text-white py-3 rounded-lg font-semibold transition-colors mb-6"
              >
                Comece agora!
              </button>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-center">
                  <svg className="w-5 h-5 text-orange-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Até 1 sistema
                </li>
                <li className="flex items-center">
                  <svg className="w-5 h-5 text-orange-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Até 1.000 acessos
                </li>
                <li className="flex items-center">
                    <svg className="w-5 h-5 text-orange-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Elementos interativos
                </li>
                <li className="flex items-center">
                    <svg className="w-5 h-5 text-orange-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Pixel e Scripts de trackeamento
                </li>
                <li className="flex items-center"></li>
               
              </ul>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-8 border">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Basic</h3>
              <p className="text-gray-600 mb-4">Ideal para quem está começando a escalar.</p>
              <div className="text-3xl font-bold text-orange-600 mb-6">
                <strike style={{color: "gray", fontSize: "19px"}}><small>R$ 197,00</small></strike><br></br>
                R$ 97,00<span className="text-lg font-normal text-orange-600">/mês</span>
              </div>
              <button
                onClick={() => handleModal("https://pay.kiwify.com.br/YFs7f8C")}
                className="w-full bg-orange-600 hover:bg-orange-700 text-white py-3 rounded-lg font-semibold transition-colors mb-6"
              >
                Comece agora!
              </button>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-center">
                  <svg className="w-5 h-5 text-orange-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Até 3 sistemas
                </li>
                <li className="flex items-center">
                  <svg className="w-5 h-5 text-orange-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Até 10.000 acessos
                </li>
                <li className="flex items-center">
                    <svg className="w-5 h-5 text-orange-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Elementos interativos
                </li>
                <li className="flex items-center">
                  <svg className="w-5 h-5 text-orange-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Domínio personalizado
                </li>
                <li className="flex items-center">
                    <svg className="w-5 h-5 text-orange-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Pixel e Scripts de trackeamento
                </li>
                <li className="flex items-center"></li>
              </ul>
            </div>

            

            {/* Pro Plan */}
            <div className="bg-white rounded-2xl shadow-xl p-8 border-2 border-orange-600 relative">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-orange-600 text-white px-4 py-1 rounded-full text-sm font-semibold">
                  Mais vendido!
                </span>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Pro</h3>
              <p className="text-gray-600 mb-4">Perfeito para os profissionais.</p>
              <div className="text-3xl font-bold text-orange-600 mb-6">
                <strike style={{color: "gray", fontSize: "19px"}}><small>R$ 297,00</small></strike><br></br>
                R$ 197,00<span className="text-lg font-normal text-orange-600">/mês</span>
              </div>
              <button onClick={() => handleModal("https://pay.kiwify.com.br/RoZdZ38")} className="w-full bg-orange-600 hover:bg-orange-700 text-white py-3 rounded-lg font-semibold transition-colors mb-6">
                Comece agora!
              </button>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-center">
                  <svg className="w-5 h-5 text-orange-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Até 10 sistemas
                </li>
                <li className="flex items-center">
                  <svg className="w-5 h-5 text-orange-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Até 25.000 acessos
                </li>
                <li className="flex items-center">
                  <svg className="w-5 h-5 text-orange-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Elementos interativos
                </li>
                <li className="flex items-center">
                  <svg className="w-5 h-5 text-orange-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Domínio personalizado
                </li>
                <li className="flex items-center">
                    <svg className="w-5 h-5 text-orange-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Integrações e Webhooks
                </li>
                <li className="flex items-center">
                    <svg className="w-5 h-5 text-orange-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Pixel e Scripts de trackeamento
                </li>
                <li className="flex items-center"></li> 
              </ul>
            </div>

            {/* Black Plan */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Scale</h3>
              <p className="text-gray-600 mb-4">Ideal para quem joga em alto nível.</p>
              <div className="text-3xl font-bold text-orange-600 mb-6">
                <strike style={{color: "gray", fontSize: "19px"}}><small>R$ 397,00</small></strike><br></br>
                R$ 297,00<span className="text-lg font-normal text-orange-600">/mês</span>
              </div>
              <button onClick={() => handleModal("https://pay.kiwify.com.br/M0HECGP")} className="w-full bg-orange-600 hover:bg-orange-700 text-white py-3 rounded-lg font-semibold transition-colors mb-6">
                Comece agora!
              </button>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-center">
                  <svg className="w-5 h-5 text-orange-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Até 25 sistemas
                </li>
                <li className="flex items-center">
                  <svg className="w-5 h-5 text-orange-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Até 50.000 acessos
                </li>
                <li className="flex items-center">
                  <svg className="w-5 h-5 text-orange-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Elementos interativos
                </li>
                <li className="flex items-center">
                  <svg className="w-5 h-5 text-orange-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Domínio personalizado
                </li>
                <li className="flex items-center">
                  <svg className="w-5 h-5 text-orange-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Integrações e Webhooks
                </li>
                <li className="flex items-center">
                    <svg className="w-5 h-5 text-orange-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Pixel e Scripts de trackeamento
                </li>
                <li className="flex items-center"></li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-4">
          
          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2025 Hotify Digital Solutions. Todos os direitos reservados.</p>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Index